import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";

export const PanelExteriorReInspeccion = () => {

  return (
    <Grid
      container
      justifyContent="center"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "center" }}
      >
        <PanelExReinspeccionPhoto />

      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "center" }}
      >
        <PanelExReinspeccionPhoto2 />

      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "center" }}
      >
        <PanelExReinspeccionPhoto3 />

      </Grid>
    </Grid>
  );
};


//PANEL EXTERIOR REINSPECCION 

const PanelExReinspeccionPhoto = () => {
  const {
    open: openParche1,
    handleClose: handleCloseParche1,
    handleOpen: handleOpenParche1,
  } = useOpen();

  const panelExteriorRePhoto1 = useWorkflowCheckpointStore(
    (state) => state.panelExteriorRePhoto1
  );

  const setPanelExteriorRePhoto1 = useWorkflowCheckpointStore(
    (state) => state.setPanelExteriorRePhoto1
  );
  const fotoUrl = useBlobUrl(panelExteriorRePhoto1);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      label="FOTO 1"
      handleClose={handleCloseParche1}
      handleOpen={handleOpenParche1}
      open={openParche1}
      setFoto={setPanelExteriorRePhoto1}
    />

  )
}

const PanelExReinspeccionPhoto2 = () => {
  const {
    open: openParche2,
    handleClose: handleCloseParche2,
    handleOpen: handleOpenParche2,
  } = useOpen();

  const panelExteriorRePhoto2 = useWorkflowCheckpointStore(
    (state) => state.panelExteriorRePhoto2
  );

  const setPanelExteriorRePhoto2 = useWorkflowCheckpointStore(
    (state) => state.setPanelExteriorRePhoto2
  );
  const fotoUrl = useBlobUrl(panelExteriorRePhoto2);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche2}
      handleOpen={handleOpenParche2}
      label="FOTO 2"
      open={openParche2}
      setFoto={setPanelExteriorRePhoto2}
    />

  )

}

const PanelExReinspeccionPhoto3 = () => {
  const {
    open: openParche3,
    handleClose: handleCloseParche3,
    handleOpen: handleOpenParche3,
  } = useOpen();

  const panelExteriorRePhoto3 = useWorkflowCheckpointStore(
    (state) => state.panelExteriorRePhoto3
  );

  const setPanelExteriorRePhoto3 = useWorkflowCheckpointStore(
    (state) => state.setPanelExteriorRePhoto3
  );
  const fotoUrl = useBlobUrl(panelExteriorRePhoto3);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche3}
      handleOpen={handleOpenParche3}
      label="FOTO 3"
      open={openParche3}
      setFoto={setPanelExteriorRePhoto3}
    />

  )
}